import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Flex } from '@qga/roo-ui/components';

const Content = styled(Flex)`
  overflow-x: auto;
`;

const FilterBanner = ({ children }) => {
  return (
    <Box
      zIndex="2"
      position="sticky"
      top="0"
      bg="background.card"
      borderBottom="1"
      borderColor="greys.smoke"
    >
      <Container px="0">
        <Content px="3" py="4" justifyContent="start" alignItems="flex-start">
          {children}
        </Content>
      </Container>
    </Box>
  );
};

export default FilterBanner;
